import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link'

import Pixel, { PIXEL_ACTIONS } from '../components/utils/Pixel'

import OrderDetails from '../components/selling-form/OrderDetails'
import payBooking from '../api/pay-booking'
import getOrder from '../api/get-order'
import WithFooter from '../layout/WithFooter'

import Datetime from '../components/utils/Datetime'
import { Line, RedLine } from '../components/utils/Symbols'
import TicketList from '../components/selling-form/ticket-list/TicketList'
import Loader from '../components/utils/Loader'

class OrderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: null,
            requestSent: false,
            notFound: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loadOrder = this.loadOrder.bind(this);
    }

    componentDidMount() {
        this.loadOrder();
    }

    async loadOrder() {
        const response = await getOrder(this.props.match.params.orderId)
        if (!response.ok) {
            this.setState({
                notFound: true
            });
        }
        const result = await response.json()
        this.setState({
            order: result
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ requestSent: true });
        payBooking(this.props.match.params.orderId).then(response => {
            if (!response.ok) {
                this.setState({ requestSent: false });
                throw response;
            }
            return response.json();
        }).then(result => {
            if (result.success) {
                window.location.replace(result.redirectUrl);
            }
        }).then(this.loadOrder);
    }

    render() {
        if (this.state.notFound) {
            return <Redirect to={`/404`} />;
        }

        if(!this.state.order) {
            return <Loader />;
        }

        switch (this.state.order.status) {
            case 'new':
            case 'payment_in_progress':
                return this.renderBookedOrder();
            case 'paid_up':
                return this.renderPaidUpOrder();
            case 'refund_in_progress':
                return this.renderRefundingOrder();
            case 'refunded':
                return this.renderRefundedOrder();
            case 'payment_cancelled':
                return this.renderCancelledPayment();
            case 'payment_refused':
                return this.renderRefusedPayment();
            case 'error':
                return this.renderErrorStatus();
            default:
                return <Redirect to={`/404`} />;
        }
    }

    renderBookedOrder = () => {
        return (
            <WithFooter>
                <Pixel orderId={this.props.match.params.orderId}
                       action={PIXEL_ACTIONS.PURCHASE_ATTEMPT}/>
                <form onSubmit={this.handleSubmit}>
                    <h3>Вы успешно забронировали билеты</h3>
                    <OrderDetails order={this.state.order} />
                    <input className="button-primary u-full-width"
                           type="submit"
                           value="Оплатить билеты"
                           disabled={this.state.requestSent}/>
                </form>
            </WithFooter>
        );
    }

    renderPaidUpOrder = () => {
        return (
            <WithFooter>

                <div className="tickets-popup-head">Поздравляем!</div>

                <div style={{whiteSpace: 'pre-wrap'}}>
                    {this.state.order.order_message}
                </div>

                <RedLine />

                <div className="tickets-customer-info-block">
                    <div>
                        Информация о покупателе:
                    </div>
                    <div>
                        Имя: {this.state.order.customer.name}
                    </div>
                    <div>
                        E-mail: {this.state.order.customer.email}
                    </div>
                </div>

                <Line />

                <div className="tickets-popup-head">
                    {this.state.order.performance.name}
                </div>
                <div>
                    <Datetime datetime={this.state.order.performance.datetime} />
                </div>
                <div>
                    {this.state.order.performance.hall}
                </div>
                
                <Line />

                <div className="tickets-list-block">
                    <TicketList tickets={this.state.order.tickets} />
                </div>


                <div>
                    Если вы хотите вернуть билеты, ознакомьтесь с&nbsp;
                    <Link to={{pathname: '/public_offer', hash: '#return-policy'}}>
                        Правилами возврата билетов
                    </Link>&nbsp;и напишите письмо на&nbsp;
                    <a href="mailto:ticket@kudago.com">ticket@kudago.com</a>
                </div>

                <div className="tickets-orders-button-block">

                    <button className="tickets-button-primary"
                            title='Распечатать билеты'
                            onClick={window.print}>
                        Распечатать билеты
                    </button>

                    <Link to="#"
                            className=""
                            onClick={this.goToBooking}
                            title='Купить еще билеты'>
                        Купить ещё билеты
                    </Link>

                </div>

                <Pixel action={PIXEL_ACTIONS.VIEW_TICKETS_PAGE} />

            </WithFooter>
        );
    }

    renderRefundingOrder = () => {
        return (
            <WithFooter>
                <h3>{this.state.order.customer.name}, ваши билеты в процессе возврата...</h3>
                <p>
                    Заявка на отмену в ожидании ручной проверки. 
                    Когда все будет готово, вы получите уведомление 
                    по электронной почте.
                </p>
                <button 
                    onClick={this.goToBooking}
                    title='Приобрести другие билеты на это мероприятие'
                    >Купить другие билеты</button>
            </WithFooter>
        );
    }

    renderRefundedOrder = () => {
        return (
            <WithFooter>
                <h3>Вы успешно вернули билеты!</h3>
                <p>
                    Средства должны вернуться на ваш счет 
                    в течение 30 дней.
                </p>
                <button 
                    onClick={this.goToBooking}
                    title='Приобрести другие билеты на это мероприятие'
                    >Купить другие билеты</button>
            </WithFooter>
        );
    }

    renderRefusedPayment = () => {
        return (
            <WithFooter>
                <h3>Платеж отклонен</h3>
                <p>
                    Вашу покупку оплатить не удалось.
                    Банк отклонил попытку оплаты.
                    Если вы считаете, что произошла 
                    ошибка, пожалуйста, свяжитесь 
                    со службой поддержки.
                </p>
                <button 
                    className="tickets-button-primary"
                    onClick={this.goToBooking}
                    title='Попробуйте приобрести другие билеты на это мероприятие'
                    >Попробовать еще раз</button>
                <Pixel action={PIXEL_ACTIONS.VIEW_PURCHASE_REFUSED_PAGE} />
            </WithFooter>
        );
    }

    renderCancelledPayment = () => {
        return (
            <WithFooter>
                <h3>Платеж отменен</h3>
                <button 
                    onClick={this.goToBooking}
                    title='Приобрести другие билеты на это мероприятие'
                    >Купить другие билеты</button>
            </WithFooter>
        );
    }

    renderErrorStatus = () => {
        return (
            <WithFooter>
                <h3>Произошла ошибка</h3>
                <button 
                    onClick={this.goToBooking}
                    title='Приобрести другие билеты на это мероприятие'
                    >Купить другие билеты</button>
            </WithFooter>
        );
    }

    goToBooking = () => {
        var newUrl = `/event/${this.state.order.performance.event.uuid}/performance/${this.state.order.performance.uuid}/`;
        window.location.assign(newUrl);
    };
}

export default OrderPage;
